import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styles from './ViewFeedbackDetails.module.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import useModal from '../../../hooks/useModal';
import ShowResolverInfoModal from '../../basic-component/Modal/ShowResolverInfoModal';
import useAxiosFetchData from '../../../hooks/useAxiosFetchData';
import API_Routes from '../../../../constants/api-routes';
import { useSelector } from 'react-redux';
import useDialog from '../../../hooks/useAddModal';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976D2', // Adjust color as needed
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif', // Adjust font family as needed
  },
});

const FeedBackDetailsClose = ({ data }) => {
  const { t } = useTranslation();
  const [userListFormData, setUserListFormData] = useState({
    "id": data.latestReceipt?.assigneeGroup.id,
    "department": {
      "id": data?.department.id
    }
  });
  const { csrfToken } = useSelector((state) => state.csrf);
  const [headers, setHeaders] = useState({
    'X-Csrf-Token': csrfToken,
    'Content-Type': 'application/json'
  });
  const [row, setRow] = useState([]);
  const { response: userListFeedbackResponse } = useAxiosFetchData({
    url: API_Routes.getUserListfromGroupName,
    method: 'post',
    body: userListFormData,
    headers: headers,
    onLoad: true
  });
 
  console.log(userListFeedbackResponse);
 
  const handleAssigneeView = (e) => {
 
    toggle();
  }
  const [feedbackCode, setFeedbackCode] = useState("");
  const [currentStatus, setCurrentStatus] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [feedbackGivenBy, setFeedbackGivenBy] = useState("");
  const [emailId, setEmailId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [dateOfFeedback, setDateOfFeedback] = useState("");
  const [feedbackDescription, setFeedbackDescription] = useState("");
  const { isShowing, toggle } = useModal({ state: false });
  const { isOpen, toggleModal} = useDialog();
  const [feedbackDetail, setFeedbackDetails] = useState("");
  const [tagged, setTaggedFeedback] = useState("");
  const [selectedTaggedFeedbackId, setSelectedTaggedFeedbackId] = useState(null); // State for selected feedback ID
  console.log("hi" + data);
  const generateAppropriateDate = (value) => {
    if (value === undefined || value === null) {
      return "N/A";
    } else {
      const date = new Date(value);
      const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      return formattedDate;
    }
  };

  const handleTaggedFeedbackClick = (id) => {
    setSelectedTaggedFeedbackId(id);
  };

  const generateTaggedFeedbacks = () => {
    if (typeof data.taggedFeedbackList !== 'undefined' && data.taggedFeedbackList.length > 0) {
      return data.taggedFeedbackList.map((feedback, index) => (
        <React.Fragment key={feedback.id}>
          <span onClick={() => handleTaggedFeedbackClick(feedback.id)}>
            <u>{feedback.feedbackCode}</u>
          </span>
          {index !== data.taggedFeedbackList.length - 1 && ', '}
        </React.Fragment>
      ));
    }
    return null;
  };

  useEffect(() => {
   if (userListFeedbackResponse) {
      setRow(userListFeedbackResponse.map((optiondata, index) => [
        optiondata.firstName + " " + optiondata.lastName
      ]));
    }
    if (data && data.feedbackDetails && data.feedbackDetails.user) {
      const stringifiedData = data;
      const createDate = stringifiedData?.feedbackDetails?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      setFeedbackCode(stringifiedData?.feedbackDetails?.feedbackCode || "");
      setCurrentStatus(stringifiedData?.feedbackDetails?.status || "");
      setFeedbackType(stringifiedData?.feedbackDetails?.feedbackType?.description || "");
      setOrganizationName(stringifiedData?.feedbackDetails?.user?.orgName || "");
      setFeedbackGivenBy(stringifiedData.feedbackDetails.user.firstName + ' ' + stringifiedData.feedbackDetails.user.lastName);
      setEmailId(stringifiedData?.feedbackDetails?.user?.email || "");
      setMobileNumber(stringifiedData?.feedbackDetails?.user?.mobile || "");
      setPhoneNumber(stringifiedData?.feedbackDetails?.user?.phone || "");
      setAddress(stringifiedData?.feedbackDetails?.user?.addressLine || "NA");
      setCreatedBy(stringifiedData?.feedbackDetails?.creator?.username || "");
      setDateOfFeedback(generateAppropriateDate(parsedDate));
      setFeedbackDescription(stringifiedData.feedbackDetails.description);
    }
    else if (data && data.id) {
      const stringifiedData = data;
      const createDate = stringifiedData?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      setFeedbackCode(stringifiedData?.feedbackCode || "");
      setCurrentStatus(stringifiedData?.status || "");
      setFeedbackType(stringifiedData?.feedbackType?.description || "");
      setOrganizationName(stringifiedData?.organizationName || "");
      setFeedbackGivenBy(stringifiedData.createFirstName + ' ' + stringifiedData.createLastName);
      setEmailId(stringifiedData?.emailId || "");
      setMobileNumber(stringifiedData?.mobileNo || "");
      setPhoneNumber(stringifiedData?.phoneNo || "");
      setAddress(stringifiedData?.user?.addressLine || "NA");
      setCreatedBy(stringifiedData?.feedbackUserFirstName + ' ' + stringifiedData?.feedbackUserLastName);
      setDateOfFeedback(generateAppropriateDate(parsedDate));
      setFeedbackDescription(stringifiedData.feedbackDesc);
      setTaggedFeedback(stringifiedData?.taggedFeedbackList || "");
    }
  }, [data, userListFeedbackResponse]);

  return (
    <ThemeProvider theme={theme}>
      <ShowResolverInfoModal
        isShowing={isShowing}
        hide={toggle}
        handleUserList={row}
      />
      <Paper elevation={0} style={{ padding: '7px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}  >
            <Typography className={styles.fontStyle}>
              {t('label.new.feedbacklist.feedbackCdoe')}:  <span className={styles.fonttext}> {feedbackCode}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('feedbackDetails.currentStatus.text')}: <span className={styles.fonttext}>{currentStatus}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('report.page.aging.table.header.feedbacktype')}: <span className={styles.fonttext}> {feedbackType}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('feedbackDetails.organizationName.text')}: <span className={styles.fonttext}>{organizationName}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('feedbackDetails.feedbackGiven.text')}: <span className={styles.fonttext}>{feedbackGivenBy}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('general.label.email')}:  <span className={styles.fonttext}>{emailId}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('menu.key.master.group')}: 
              { data?.latestReceipt && data.latestReceipt.assigneeGroup && (
              <TableContainer component={Paper} style={{ marginBottom: '20px' }}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#867FA1' }}>
                      <TableCell className={styles.tableHeight}>{t('general.label.serial.number.short')}</TableCell>
                      <TableCell className={styles.tableHeight}>{t('feedbackDetails.groupName.text')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
 
                    <TableRow key={1}>
                      <TableCell>{1}</TableCell>
                      <TableCell>{data.latestReceipt.assigneeGroup.name}
                        <i class="fa fa-external-link" aria-hidden="true" onClick={(e) => handleAssigneeView(e)}></i></TableCell>
                      {/* <TableCell></TableCell> */}
                    </TableRow>
 
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            </Typography>

            <Typography className={styles.fontStyle}>
              {t('general.label.tagged')}: <span className={styles.fonttext}>{generateTaggedFeedbacks()}</span>
            </Typography>
          </Grid>
         
          <Grid item xs={12} sm={6}>
            <Typography className={styles.fontStyle}>
              {t('general.field.mobile.label')}: <span className={styles.fonttext}>{mobileNumber}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('general.field.phone.label')}: <span className={styles.fonttext}>{phoneNumber}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('feedbackDetails.address.text')}: <span className={styles.fonttext}>{address}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('feedbackDetails.createdBy.text')}: <span className={styles.fonttext}>{createdBy}</span>
            </Typography>
            <Typography className={styles.fontStyle}>
              {t('label.new.feedbacklist.DateOfFeedback')}: <span className={styles.fonttext}>{dateOfFeedback}</span>
            </Typography>
            <Typography className={styles.feedbackDescriptionContainer + " " + styles.fontStyle} >
              {t('feedbackDetails.feedbackDescription.text')}: <span className={styles.fonttext} dangerouslySetInnerHTML={{ __html: feedbackDescription }} />
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </ThemeProvider>
  );
};

export default FeedBackDetailsClose;
